document.addEventListener("click", function (e) {
  // Check if clicked element or one of its parents has class 'flash-close'
  const closeBtn = e.target.closest(".flash-close");
  if (!closeBtn) return;

  const flash = closeBtn.closest(".flash");
  if (flash) {
    flash.remove();
  }
});
